import { render, staticRenderFns } from "./Siscobra.vue?vue&type=template&id=61bcfa5e&scoped=true"
import script from "./Siscobra.vue?vue&type=script&lang=js"
export * from "./Siscobra.vue?vue&type=script&lang=js"
import style0 from "./Siscobra.vue?vue&type=style&index=0&id=61bcfa5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bcfa5e",
  null
  
)

export default component.exports